export default {"src":"/_next/static/media/floating_dollar.a56eef61.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};